import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type CheckoutRequestDTO = {
  amount_cents: string;
  currency: string;
  billing_data?: {
    street?: string;
    building?: string;
    city?: string;
    country?: string;
    landing?: string;
    floor?: string;
    state?: string;
    apartment?: string;
  };
};

type CheckoutResponse = {
  checkoutLink: string;
} & ApiError;

export const CheckoutCart = (
  data: CheckoutRequestDTO
): Promise<CheckoutResponse> => {
  return axios
    .post(`/payment/checkout`, data)
    .then((response) => response.data as CheckoutResponse);
};
